// Service errors arrive as a string or an { message } object (services/* never
// throw); this turns either into text for a toast or an inline error.
export function msg(e, fallback = "Something went wrong. Please try again.") {
  if (!e) return fallback;
  if (typeof e === "string") return e;
  return e.message || fallback;
}
